import { EventTypeEnum } from '../models/event-type';

export const EventTypeLabelPipe = eventType => {
    switch (eventType) {
        case EventTypeEnum.REGISTER:
            return 'Register';
        case EventTypeEnum.DEPOSIT:
            return 'Deposit';
        case EventTypeEnum.WITHDRAWAL:
            return 'Withdrawal';
        case EventTypeEnum.BASIC_ID_GATHERED:
            return 'Basic ID';
        case EventTypeEnum.BASIC_INFO_GATHERED:
            return 'Basic Info';
        case EventTypeEnum.PHOTOGRAPHIC_EVIDENCE_GATHERED:
            return 'Photographic Evidence';
        case EventTypeEnum.PEP_CHECK_DONE:
            return 'PEP Check';
        case EventTypeEnum.SANCTION_CHECK_DONE:
            return 'Sanction Check';
        case EventTypeEnum.EVIDENCE_OF_SOW_INCOME_OCCUPATION_DONE:
            return 'Evidence of Low Income';
        case EventTypeEnum.DUE_DILIGENCE_DONE:
            return 'Due Diligence';
        case EventTypeEnum.BET:
            return 'Bet';
        case EventTypeEnum.CHAT:
            return 'Chat';
        case EventTypeEnum.ASK_FOR_OFFERS:
            return 'Offers Demand';
        default:
            return eventType;
    }
};
